import angular from 'angular'; // need this otherwise build errors ensue
import $ from "jquery";
import axios from "axios";

let instance: AxiosInstance;

export const getHttpClient = async (): Promise<AxiosInstance> => {
    if(!instance) {
        instance = axios.create();
        instance.defaults.baseURL = '/api';

        const token = sessionStorage.getItem('authorization_token');

        if (!token) {
            const tokenResults = await $.ajax('/AuthTokenMvc/GetToken', {
                method: 'POST'
            });

            sessionStorage.setItem('authorization_token', tokenResults.token);
            instance.defaults.headers.common['Authorization'] = tokenResults.token ? `Bearer ${tokenResults.token}` : '';
        }
        else {
            instance.defaults.headers.common['Authorization'] = token;
        }
    }

    return instance;
}

export const setAuthToken = async (token: string) => {
    const client = await getHttpClient();

    sessionStorage.setItem('authorization_token', token);
    client.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : '';

    ascommon.log('HttpClient: configured auth token');
}
